

































import Vue from 'vue';

export default Vue.extend({
  props: {
    name: {
      type: String as () => string,
      required: true,
    },
    photo: {
      type: String as () => string | null,
    },
  },
});
